import React, { Component } from 'react';
import { BeatLoader } from 'react-spinners';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types'
import NotificationSystem from 'react-notification-system';
import { _delete, get, postWithHeaders, patch, postWithHeadersResponse } from '../../../server/actions';
import { _addNotification, _addNotificationError, getModuleEnum, getSchoolGrades, numberOnly } from '../../../server/util'
class SchoolRec extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            loading: false,
            countryList: [],
            SchoolTypes: [],
            typeOfSchools: [],
            typeOfSchoolByGrade: [],
            mealEligibilityProgram: [],
            schoolInformationSystem: [],
            selectedSchoolTypeId: null,
            selectedSchoolByGradeId: null,
            selectedMealEligibilityProgram: null,
            selectedSchoolInfoSystem: null,
            school: {

            }
        }
    }
    componentWillMount = () => {
        let id = parseInt(this.props.match.params.id || 0);
        this.setState({ id: id }, () => {
            if (id > 0) {
                this.getSchoolDetails(id);
            }
        });
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.getCountryList();
        this.getSchoolType();
        this.getschoolInformationSystemData();
        this.getTypeOfSchoolsData();
        this.getTypeOfSchoolByGradesData();
        this.getMealEligibilityProgramsData();
    }

    getTypeOfSchoolsData = () => {
        this.setState({ loading: true })
        get(`/typeOfSchools?access_token=`).then((response) => {
            this.setState({ loading: false });
            if (!response.ok) {
                throw Error(response.statusMessage);
            }
            return response.json();
        }).then(data => {
            this.setState({ typeOfSchools: data._embedded.typeOfSchools });
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('status', error);
            }
        )
    }

    getTypeOfSchoolByGradesData = () => {
        this.setState({ loading: true })
        get(`/typeOfSchoolByGrades?access_token=`).then((response) => {
            this.setState({ loading: false });
            if (!response.ok) {
                throw Error(response.statusMessage);
            }
            return response.json();
        }).then(data => {
            this.setState({ typeOfSchoolByGrade: data._embedded.typeOfSchoolByGrades });
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('status', error);
            }
        )
    }

    getMealEligibilityProgramsData = () => {
        this.setState({ loading: true })
        get(`/mealEligibilityPrograms?access_token=`).then((response) => {
            this.setState({ loading: false });
            if (!response.ok) {
                throw Error(response.statusMessage);
            }
            return response.json();
        }).then(data => {
            this.setState({ mealEligibilityProgram: data._embedded.mealEligibilityPrograms });
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('status', error);
            }
        )
    }

    getschoolInformationSystemData = () => {
        this.setState({ loading: true })
        get(`/schoolInformationSystems?access_token=`).then((response) => {
            this.setState({ loading: false });
            if (!response.ok) {
                throw Error(response.statusMessage);
            }
            return response.json();
        }).then(data => {
            this.setState({ schoolInformationSystem: data._embedded.schoolInformationSystems });
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('status', error);
            }
        )
    }

    getSchoolType = () => {
        this.setState({ loading: true });
        get(`/schoolTypes?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let list = Object.keys(data).map(keyname => {
                return { label: keyname, value: keyname }
            })
            this.setState({ SchoolTypes: list, loading: false })
        }).catch(error => {
            this.setState({ loading: false });
            console.log("Loading Report Failed", error)
        })
    }
    getSchoolDetails = (id) => {
        this.setState({ loading: true });
        get(`/schools/${id}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({
                loading: false,
                school: data,
                selectedSchoolTypeId: data.typeOfSchool ? data.typeOfSchool.id : null,
                selectedSchoolByGradeId: data.typeOfSchoolByGrade ? data.typeOfSchoolByGrade.id : null,
                selectedMealEligibilityProgram: data.mealEligibilityProgram ? data.mealEligibilityProgram.id : null,
                selectedSchoolInfoSystem: data.schoolInformationSystem ? data.schoolInformationSystem.id : null,
            });
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('Onboard School response', error)
            }
        )
    }
    getCountryList() {
        this.setState({ loading: true });
        get('/countryDetails?&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let countryList = [];
            data._embedded.countryDetails.forEach(function (val) {
                countryList.push({ country: val.countryName, label: val.countryCode + ' (' + val.countryName + ')', value: val.countryCode });
            });
            this.setState({
                loading: false,
                countryList: countryList
            },
            )
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('Onboard School response', error)
            }
        )
    }
    handleSchoolNameChange = (evt) => {
        const school = this.state.school;
        school['schoolName'] = evt.target.value;
        this.setState({ school: school });
    };
    handleSchoolAddressChange = (evt) => {
        const school = this.state.school;
        school['schoolAddress'] = evt.target.value
        this.setState({ school: school });
    };
    handleZipChange = (evt) => {
        const school = this.state.school;
        school['cityStateZip'] = evt.target.value;
        this.setState({ school: school });
    };
    handleCityChange = (evt) => {
        const school = this.state.school;
        school['city'] = evt.target.value;
        this.setState({ school: school });
    };
    handleCtdsChange = (evt) => {
        const school = this.state.school;
        school['ctds'] = evt.target.value;
        this.setState({ school: school });
    };
    handleTelephoneNoChange = (evt) => {
        const school = this.state.school;
        school['telephone'] = evt.target.value;
        this.setState({ school: school });
    }
    handleDistrictNameChange = (evt) => {
        const school = this.state.school;
        school['schoolDistrictName'] = evt.target.value;
        this.setState({ school: school });
    };
    handleFaxChange = (evt) => {
        const school = this.state.school;
        school['fax'] = evt.target.value;
        this.setState({ school: school });
    };
    handleCountyChange = (selectedItem) => {
        const school = this.state.school;
        school['country'] = selectedItem.countryName;
        school['countryCode'] = selectedItem.value;
        this.setState({ school: school });
    };
    handleSchoolTypeChange = (selectedItem) => {
        const school = this.state.school;
        school['schoolType'] = (selectedItem || []).map(item => {
            return item.value
        });
        this.setState({ school: school });
    };
    handleStateChange = (evt) => {
        const school = this.state.school;
        school['state'] = evt.target.value;
        this.setState({ school: school });
    }
    handleTypeOfSchoolChange = (evt) => {
        this.setState({ selectedSchoolTypeId: parseInt(evt.target.value) });
    }
    handleTypeOfSchoolByGradeChange = (evt) => {
        this.setState({ selectedSchoolByGradeId: parseInt(evt.target.value) });
    }
    handleMealEligibilityProgramChange = (evt) => {
        if (evt.target.checked) {
            this.setState({ selectedMealEligibilityProgram: parseInt(evt.target.value) });
        } else {
            this.setState({ selectedMealEligibilityProgram: null });
        }

    }
    handleSchoolInformationSystemChange = (evt) => {
        if (evt.target.value == '') {
            this.setState({ selectedSchoolInfoSystem: null });
        } else {
            this.setState({ selectedSchoolInfoSystem: parseInt(evt.target.value) });
        }
    }
    validate = () => {
        const self = this;
        const { school } = this.state;
        if ((school.schoolName || '').trim().length === 0) {
            _addNotificationError('Please enter school name', self);
            return false
        }
        if ((school.schoolAddress || '').trim().length === 0) {
            _addNotificationError('Please enter school address', self);
            return false
        }
        if ((school.city || '').trim().length === 0) {
            _addNotificationError('Please enter city', self);
            return false
        }
        if ((school.countryCode || '').trim().length === 0) {
            _addNotificationError('Please select country', self);
            return false
        }
        if ((school.state || '').trim().length === 0) {
            _addNotificationError('Please enter state', self);
            return false
        }
        if ((school.cityStateZip || '').trim().length === 0) {
            _addNotificationError('Please enter zip', self);
            return false
        }

        if ((school.schoolType || []).length === 0) {
            _addNotificationError('Please select school type', self);
            return false
        }
        if ((school.telephone || []).length === 0) {
            _addNotificationError('Please enter telephone no', self);
            return false
        }
        if ((this.state.selectedSchoolTypeId || []).length === 0) {
            _addNotificationError('Please select Type of School', self);
            return false
        }
        if ((this.state.selectedSchoolByGradeId || []).length === 0) {
            _addNotificationError('Please select Type of School By Grade', self);
            return false
        }
        /*  if((this.state.selectedMealEligibilityProgram||[]).length===0){
             _addNotificationError('Please select Meal Eligibility Program', self);
             return false
         } */
        /*  if((this.state.selectedSchoolInfoSystem||[]).length===0){
             _addNotificationError('Please select School Information System', self);
             return false
         } */
        return true
    }
    onSchoolDetailsSubmit = () => {
        const self = this;
        const { school } = this.state;
        let loggedUserInfo = sessionStorage.getItem('loggedInUserInfo');
        let loggedUser = loggedUserInfo;
        let schools = {};
        if (!this.validate()) {
            return false
        }
        schools = {
            "loggedUser": loggedUser,
            "schoolName": school.schoolName,
            "county": school.county,
            "countryCode": school.countryCode,
            "city": school.city,
            "telephone": school.telephone,
            "fax": school.fax,
            "schoolAddress": school.schoolAddress,
            "ctds": school.ctds,
            "schoolDistrictName": school.schoolDistrictName,
            "schoolType": school.schoolType,
            "state": school.state,
            "cityStateZip": school.cityStateZip,
            "typeOfSchool": {
                "id": this.state.selectedSchoolTypeId
            },
            "typeOfSchoolByGrade": {
                "id": this.state.selectedSchoolByGradeId
            },
        };
        if (this.state.selectedMealEligibilityProgram) {
            schools['mealEligibilityProgram'] = {
                "id": this.state.selectedMealEligibilityProgram
            }
        } else {
            schools['mealEligibilityProgram'] = undefined;
        }
        if ((this.state.selectedSchoolInfoSystem || []).length > 0) {
            schools['schoolInformationSystem'] = {
                "id": this.state.selectedSchoolInfoSystem
            }
        } else {
            schools['schoolInformationSystem'] = undefined;
        }
        if (this.state.id <= 0) {
            let headers = {
                'Content-Type': 'application/json'
            };
            postWithHeaders('/schools?access_token=', JSON.stringify(schools), headers).then((response) => {
                if (response.status !== 201) {
                    throw Error(response.statusText);
                }
                return response;
            }).then(data => {
                _addNotification('School Added Successfully.', self);
                setTimeout(() =>
                    this.context.router.history.push('/superAdmin/schools')
                    , 3000);
            }).catch(
                (error) => {
                    _addNotificationError('Failed to create new school.', this);
                }
            );
        } else {
            patch(`/schools/v2/${this.state.id}?access_token=`, JSON.stringify(schools)).then((response) => {
                if (response.status !== 200) {
                    throw Error(response.statusText);
                }
                return response;
            }).then(data => {
                _addNotification('School updated successfully.', self);
                setTimeout(() =>
                    this.context.router.history.push('/superAdmin/schools')
                    , 3000);
            }).catch(
                (error) => {
                    _addNotificationError(error.message, self);
                }
            );

        }
    };
    render() {
        const { school } = this.state;
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <section className=" full-width clearfix">
                    <div className="container">
                        <div className='sweet-loading'
                            style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="sectionTitle col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <h2 style={{ marginBottom: '5px' }}><span>School</span></h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-xs-3 col-xs-offset-1">
                                            <div className="form-group">
                                                <label htmlFor={`School Name`}>School Name*</label>
                                                <input id={`School Name`}
                                                    value={school.schoolName}
                                                    type="text" className="form-control"
                                                    placeholder={`School Name`}
                                                    style={{ marginRight: '20px' }}
                                                    onChange={(e) => this.handleSchoolNameChange(e)} />
                                            </div>
                                        </div>
                                        <div className="col-xs-3">
                                            <div className="form-group">
                                                <label htmlFor={`School Address`}>School Address*</label>
                                                <input type="text" className="form-control" id={`School Address`}
                                                    value={school.schoolAddress}
                                                    placeholder={`School Address`}
                                                    style={{ marginRight: '20px' }}
                                                    onChange={(e) => this.handleSchoolAddressChange(e)}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-xs-3 ">
                                            <div className="form-group">
                                                <label htmlFor={`City`}>City*</label>
                                                <input
                                                    type="text" className="form-control" id={`City`}
                                                    placeholder={` City`}
                                                    value={school.city}
                                                    onChange={(e) => this.handleCityChange(e)}
                                                    style={{ marginRight: '20px' }}

                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-3 col-xs-offset-1">
                                            <div className="form-group">
                                                <label htmlFor={`County`}>Country*</label>
                                                <Select
                                                    onChange={(e) => this.handleCountyChange(e)}
                                                    value={this.state.countryList.find(itm => {
                                                        return itm.value === school.countryCode
                                                    })}
                                                    closeMenuOnSelect={true}
                                                    options={this.state.countryList}
                                                    //className="basic-multi-select"
                                                    classNamePrefix="select"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xs-3">
                                            <div className="form-group">
                                                <label htmlFor={`Country Code`}>Country Code*</label>
                                                <input
                                                    type="text" className="form-control"
                                                    placeholder={` Country Code`}
                                                    value={school.countryCode}
                                                    style={{ marginRight: '20px' }} disabled
                                                //onChange={(e)=>this.handleCountryCodeChange(e)}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-xs-3">
                                            <div className="form-group">
                                                <label htmlFor={`State`}>State*</label>
                                                <input
                                                    type="text" className="form-control" id={`State`}
                                                    placeholder={` State`}
                                                    value={school.state}
                                                    style={{ marginRight: '20px' }}
                                                    onChange={(e) => this.handleStateChange(e)}

                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-3 col-xs-offset-1">
                                            <div className="form-group">
                                                <label htmlFor={`cityStateZip`}>Zip*</label>
                                                <input type="text" className="form-control" id={` cityStateZip`}
                                                    value={school.cityStateZip}
                                                    placeholder={`Zip`}
                                                    style={{ marginRight: '20px' }}
                                                    onChange={(e) => this.handleZipChange(e)}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-xs-3">
                                            <div className="form-group">
                                                <label htmlFor={`School DistrictName`}>School DistrictName</label>
                                                <input type="text"
                                                    className="form-control"
                                                    value={school.schoolDistrictName}
                                                    id="School DistrictName"
                                                    placeholder={'School DistrictName'}
                                                    onChange={(e) => this.handleDistrictNameChange(e)}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-xs-3">
                                            <div className="form-group">
                                                <label htmlFor={`school Type`}>School Type*</label>
                                                <Select
                                                    value={(school.schoolType || []).map(item => {
                                                        return { label: item, value: item }
                                                    })}
                                                    onChange={(e) => this.handleSchoolTypeChange(e)}
                                                    isMulti
                                                    closeMenuOnSelect={false}
                                                    options={this.state.SchoolTypes}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-3 col-xs-offset-1">
                                            <div className="form-group">
                                                <label htmlFor={`Telephone`}>Telephone*</label>
                                                <input type="text" className="form-control" id={`Telephone`}
                                                    placeholder={`Telephone`}
                                                    style={{ marginRight: '20px' }}
                                                    value={school.telephone}
                                                    maxLength={this.state.mobileLength}
                                                    onKeyPress={numberOnly}
                                                    onChange={(e) => this.handleTelephoneNoChange(e)}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-xs-3">
                                            <div className="form-group">
                                                <label htmlFor={`Fax`}>Fax</label>
                                                <input type="text"
                                                    className="form-control"
                                                    value={school.fax}
                                                    id="Fax"
                                                    placeholder={'Fax'}
                                                    maxLength={this.state.mobileLength}
                                                    onKeyPress={numberOnly}
                                                    onChange={(e) => this.handleFaxChange(e)}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-xs-3">
                                            <div className="form-group">
                                                <label htmlFor={`Ctds`}>Ctds</label>
                                                <input type="text"
                                                    value={school.ctds}
                                                    className="form-control"
                                                    id="Ctds"
                                                    placeholder={'Ctds'}
                                                    onChange={(e) => this.handleCtdsChange(e)}

                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-3 col-xs-offset-1">
                                            <div className="form-group">
                                                <label htmlFor={`Type Of School`}>Type Of School*</label>
                                                {
                                                    this.state.typeOfSchools.map((school, key) => {
                                                        return (
                                                            <div>
                                                                <input type="radio" id={school.id} value={school.id} checked={this.state.selectedSchoolTypeId === school.id ? true : false}
                                                                    onChange={(e) => {
                                                                        this.handleTypeOfSchoolChange(e);
                                                                    }} />
                                                                <label htmlFor={school.id}>{school.type}</label>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="col-xs-3">
                                            <div className="form-group">
                                                <label htmlFor={`Type Of Schools By Grade`}>Type Of Schools By Grade*</label>
                                                {
                                                    this.state.typeOfSchoolByGrade.map((grade, key) => {
                                                        return (
                                                            <div>
                                                                <input type="radio" id={"selectedSchoolByGradeId" + grade.id} value={grade.id} checked={this.state.selectedSchoolByGradeId === grade.id ? true : false} onChange={(e) => {
                                                                    this.handleTypeOfSchoolByGradeChange(e);
                                                                }} /> <label htmlFor={"selectedSchoolByGradeId" + grade.id}>{grade.type}</label>
                                                            </div>)
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="col-xs-3 ">
                                            <div className="form-group">
                                                <label htmlFor={`Meal Eligibility Program`}>Meal Eligibility Program</label>
                                                {
                                                    this.state.mealEligibilityProgram.map((school, key) => {
                                                        return (
                                                            <div style={{ width: '120%' }}>
                                                                <input type="checkbox" id={"selectedMealEligibilityProgram" + school.id} value={school.id} checked={this.state.selectedMealEligibilityProgram === school.id ? true : false}
                                                                    onChange={(e) => {
                                                                        this.handleMealEligibilityProgramChange(e);
                                                                    }} />
                                                                <label htmlFor={"selectedMealEligibilityProgram" + school.id}>{school.program}</label>
                                                            </div>)
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-3 col-xs-offset-1">
                                            <div className="form-group">
                                                <label htmlFor={`School Information System`}>School Information System</label>
                                                <select className="form-control" value={this.state.selectedSchoolInfoSystem || ''} onChange={(e) => {
                                                    this.handleSchoolInformationSystemChange(e);
                                                }} >
                                                    <option value=""> Select </option>
                                                    {this.state.schoolInformationSystem &&
                                                        this.state.schoolInformationSystem.map((school, key) => {
                                                            return <option value={school.id} >{school.type}</option>;
                                                        })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="text-right add-schools-footer">
                                    <Link to="/superAdmin/schools">
                                        <button type="button" id="cancelAdd" className="btn btn-primary btn-lg"
                                            style={{ margin: 0, fontSize: 14, marginTop: "10px" }}><i
                                                className="glyphicon glyphicon-remove"
                                                style={{ marginRight: 0, paddingLeft: 0 }}></i> Cancel
                                        </button>
                                    </Link>
                                    <button
                                        className="btn btn-success btn-lg"
                                        style={{
                                            margin: 0, marginLeft: 5, fontSize: 14, marginTop: "10px"
                                        }}
                                        onClick={(e) => {
                                            this.onSchoolDetailsSubmit(e);
                                        }}>
                                        <i className="glyphicon glyphicon-ok" style={{ marginRight: '0', paddingLeft: '0' }}></i> Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}
SchoolRec.contextTypes = {
    router: PropTypes.object.isRequired
}
export default SchoolRec;



// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Schools/schoolRec.jsx